import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import { getUserData, syncUserData } from "../services/storeApi";

const initialSessionId = localStorage.getItem("guest_session") || uuidv4();
localStorage.setItem("guest_session", initialSessionId);


// ✅ SYNC CART & WISHLIST WITH BACKEND
export const syncGuestData = createAsyncThunk(
  "session/syncGuestData",
  async ({ email }, { getState }) => {
    const { session } = getState();
    const payload = {
      sessionId: session.sessionId,
      email,
      cart: session.cart,
      wishlist: session.wishlist,
    };
    console.log(payload)
    await syncUserData(payload);
    return { success: true };
  }
);

export const fetchUserData = createAsyncThunk(
  "session/fetchUserData",
  async (email) => {
    const response = await getUserData(email);
    return response.data.data;
  }
);

const sessionSlice = createSlice({
  name: "session",
  initialState: {
    sessionId: initialSessionId,
    cart: JSON.parse(localStorage.getItem("cart")) || [],
    wishlist: JSON.parse(localStorage.getItem("wishlist")) || [],
    synced: false,
  },
  reducers: {
    addToCart: (state, action) => {
      const existing = state.cart.find((i) => i.SKU === action.payload.SKU);
      if (existing) existing.quantity += 1;
      else state.cart.push({ ...action.payload, quantity: 1 });
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },
    removeFromCart: (state, action) => {
      state.cart = state.cart.filter((i) => i.SKU !== action.payload.SKU);
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },
    updateQuantity: (state, action) => {
      const { id, type } = action.payload;
      state.cart = state.cart.map((item) => {
        if (item.SKU === id) {
          const qty = type === "increase" ? item.quantity + 1 : Math.max(1, item.quantity - 1);
          return { ...item, quantity: qty };
        }
        return item;
      });
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },
    clearLocalSession: (state) => {
      state.cart = [];
      state.wishlist = [];
      localStorage.removeItem("cart");
      localStorage.removeItem("wishlist");
      localStorage.removeItem("guest_session");
    },
    addToWishlist: (state, action) => {
      const exists = state.wishlist.some((i) => i.id === action.payload.id);
      if (!exists) {
        state.wishlist.push(action.payload);
        localStorage.setItem("wishlist", JSON.stringify(state.wishlist));
      }
    },
    removeFromWishlist: (state, action) => {
      state.wishlist = state.wishlist.filter((i) => i.id !== action.payload);
      localStorage.setItem("wishlist", JSON.stringify(state.wishlist));
    },
  },
  extraReducers: (builder) => {
  builder
    .addCase(syncGuestData.fulfilled, (state) => {
      state.synced = true;
    })
    .addCase(fetchUserData.fulfilled, (state, action) => {
      state.cart = action.payload.cart || [];
      state.wishlist = action.payload.wishlist || [];

      // Keep localStorage in sync
      localStorage.setItem("cart", JSON.stringify(state.cart));
      localStorage.setItem("wishlist", JSON.stringify(state.wishlist));
    });
},
});

export const {
  addToCart,
  removeFromCart,
  updateQuantity,
  addToWishlist,
  removeFromWishlist,
  clearLocalSession,
} = sessionSlice.actions;

export default sessionSlice.reducer;
